import { makeTextFieldIcon } from 'shared/ui/TextField'
import { Typography } from 'shared/ui'
import { SendFrom, type SendFromStore } from 'widgets/SendFrom'
import styles from './styles.module.scss'

type ITriggerStep2Props = {
  sendFromStore: SendFromStore
}

export const TriggerStep2 = ({ sendFromStore }: ITriggerStep2Props) => {
  return (
    <div className={styles.selectWrap}>
      <SendFrom
        store={sendFromStore}
        placement={'top-start'}
        triggerVariant={'textField'}
        width={468}
        textFiledTriggerProps={{
          textFieldPlaceholderProps: {
            variant: 'stroke',
            size: 'medium',
          },
          rightActions: [makeTextFieldIcon({ icon: 'chevronDown' })],
        }}
        propsDropdownList={{
          isTopReverse: true,
        }}
      />
      <Typography
        variant={'text-input-helper'}
        ariaLabel={'InboxHint'}
        color={'tertiary'}
        marginTop={8}
        tag='div'
      >
        To trigger the agent from incoming messages, use enrollment criteria in the next step
      </Typography>
    </div>
  )
}
